import trackers from "./trackers"
import {PERKS, RECOGNITION, MEDICAL, WALLET, PLATFORM, REWARD, ONBOARDING, TOUR, WELLNESS, getTrackingProductName} from "./products"
import mixPanelService from "./trackers/mixpanel"

export const clickEventId ="cta_button_click"

class Tracking {
  setup = (env: string) => {
    trackers.setup(env)
  }

  trackEvent = (name: string, data?: any) => {
    mixPanelService.trackEvent(name, data)
  }

  trackRecognitionEvent = (name: string, dataAttributes?: any) => {
    const productData = {
      perkbox_product: RECOGNITION
    }
    this.trackEvent(name, {...productData, ...dataAttributes})
  }

  trackRewardEvent = (name: string, dataAttributes?: any) => {
    const productData = {
      perkbox_product: REWARD
    }
    this.trackEvent(name, {...productData, ...dataAttributes})
  }

  trackPerksEvent = (name: string, dataAttributes?: any) => {
    const productData = {
      perkbox_product: PERKS
    }
    this.trackEvent(name, {...productData, ...dataAttributes})
  }

  trackMedicalEvent = (name: string, dataAttributes?: any) => {
    const productData = {
      perkbox_product: MEDICAL
    }
    this.trackEvent(name, {...productData, ...dataAttributes})
  }

  trackWalletEvent = (name: string, dataAttributes?: any) => {
    const productData = {
      perkbox_product: WALLET
    }
    this.trackEvent(name, {...productData, ...dataAttributes})
  }

  trackPlatformEvent = (name: string, dataAttributes?: any) => {
    const productData = {
      perkbox_product: PLATFORM
    }
    this.trackEvent(name, {...productData, ...dataAttributes})
  }

  trackOnboardingEvent = (name: string, dataAttributes?: any) => {
    const productData = {
      perkbox_product: ONBOARDING
    }
    this.trackEvent(name, {...productData, ...dataAttributes})
  }

  trackTourEvent = (name: string, dataAttributes?: any) => {
    const productData = {
      perkbox_product: TOUR
    }
    this.trackEvent(name, {...productData, ...dataAttributes})
  }

  trackWellnessEvent = (name: string, dataAttributes?: any) => {
    const productData = {
      perkbox_product: WELLNESS
    }
    this.trackEvent(name, {...productData, ...dataAttributes})
  }

  trackSearchEvent = (name: string, dataAttributes: any, isRewards = false) => {
    const productData = {
      perkbox_product: isRewards ? REWARD : PERKS
    }

    this.trackEvent(name, {...productData, ...dataAttributes})
  }

  trackCTAEvent = (dataAttributes?: {source: string; type: string}) => {
    const perkbox_product = getTrackingProductName()
    if (!perkbox_product) {
      return
    }
    const eventData = {
      perkbox_product,
      ...dataAttributes
    }
    this.trackEvent(clickEventId, {...eventData})
  }
}

export default new Tracking()
